// extracted by mini-css-extract-plugin
export var drawerPaper = "_1c-0";
export var itemCard = "_1c-1";
export var itemImage = "_1c-2";